export default "__VITE_ASSET__BFjzJ70B__"